"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationStepAction = exports.AuthorizationStepStatus = void 0;
var AuthorizationStepStatus;
(function (AuthorizationStepStatus) {
    AuthorizationStepStatus["LOADING_INFO"] = "loading_info";
    AuthorizationStepStatus["PENDING"] = "pending";
    AuthorizationStepStatus["WAITING"] = "waiting";
    AuthorizationStepStatus["PROCESSING"] = "processing";
    AuthorizationStepStatus["ALLOWANCE_AMOUNT_ERROR"] = "allowance_amount_error";
    AuthorizationStepStatus["ERROR"] = "error";
    AuthorizationStepStatus["DONE"] = "done";
})(AuthorizationStepStatus = exports.AuthorizationStepStatus || (exports.AuthorizationStepStatus = {}));
var AuthorizationStepAction;
(function (AuthorizationStepAction) {
    AuthorizationStepAction["REVOKE"] = "revoke";
    AuthorizationStepAction["GRANT"] = "grant";
    AuthorizationStepAction["CONFIRM"] = "confirm";
})(AuthorizationStepAction = exports.AuthorizationStepAction || (exports.AuthorizationStepAction = {}));
